/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AcquisScolaireGridDto } from './AcquisScolaireGridDto';
import {
    AcquisScolaireGridDtoFromJSON,
    AcquisScolaireGridDtoFromJSONTyped,
    AcquisScolaireGridDtoToJSON,
} from './AcquisScolaireGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface AcquisScolaireGridDtoPaginatedResults
 */
export interface AcquisScolaireGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof AcquisScolaireGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<AcquisScolaireGridDto>}
     * @memberof AcquisScolaireGridDtoPaginatedResults
     */
    results?: Array<AcquisScolaireGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof AcquisScolaireGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the AcquisScolaireGridDtoPaginatedResults interface.
 */
export function instanceOfAcquisScolaireGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function AcquisScolaireGridDtoPaginatedResultsFromJSON(json: any): AcquisScolaireGridDtoPaginatedResults {
    return AcquisScolaireGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function AcquisScolaireGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): AcquisScolaireGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(AcquisScolaireGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function AcquisScolaireGridDtoPaginatedResultsToJSON(value?: AcquisScolaireGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(AcquisScolaireGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

